module.exports = __webpack_public_path__ + "static/media/5.1cdaf6e6.jpg";